export const ROUTE_PATHS = {

  DASHBOARD: "/admin/",
  USERS: "/admin/users",
  CREATE_USER: "/admin/users/create",

  ROLES: "/admin/roles",
  ASSIGN_PERMISSIONS: "/admin/permissions",

  PRODUCT: "/admin/products",

  BANNER: "/admin/banners",
  CREATE_BANNER: "/admin/banners/create",

  BLOG_CATEGORY: "/admin/blog/categories",
  CREATE_BLOG_CATEGORY: "/admin/blog/categories/create",

  ADMIN_BLOG: "/admin/blogs",
  CREATE_BLOG: "/admin/blogs/create",

  BRAND: "/admin/brands",
  CREATE_BRAND: "/admin/brands/create",

  PRODUCT_CATEGORY: "/admin/product/categories",
  CREATE_PRODUCT_CATEGORY: "/admin/product/categories/create",

  PRODUCT_SUB_CATEGORY: "/admin/product/subcategories",
  CREATE_PRODUCT_SUB_CATEGORY: "/admin/product/subcategories/create",

  SOCIAL_LINK: "/admin/socials",

  EMAIL_TEMPLATES: "/admin/email-templates",
  EMAIL_SEND: "/admin/email-templates/send",
  CREATE_EMAIL_TEMPLATE: "/admin/email-templates/create",

  ADMIN_PROFILE: "/admin/profile",
  SETTINGS: "/admin/settings",
  WEBSITE_SETTINGS: "/admin/settings/website",
  CONTACT_SETTINGS: "/admin/settings/contact",
  CREATE_FAQS:"/admin/faqs-create",
  FAQS_LIST:"/admin/faqs",
  
  // District
  DISTRICT_LIST: "/admin/district",

  // Taluka 
  TALUKA_LIST: "/admin/taluka",

   // Lab Rest 
  LABTESTLIST: "/admin/lab/test",
  LAB_REPORT_LIST:"/admin/lab/reports",
  LAB_REPORT_CREATE:"/admin/lab/reports/create",
  // Unit
  UNIT_LIST:"/admin/unit",
  UNIT_CREATE:"/admin/unit/create",


  // Patients Management
  PATIENT_LIST:"/admin/patients",
  PATIENT_CREATE:"/admin/patients/create",

  PATIENT_VISIT_LIST:"/admin/patient-visit/",
  PATIENT_VISIT_CREATE:"/admin/patient-visit/create",

  REFERREL_LIST:"/admin/referrel-list",
  REFFERAL_CREATE:"/admin/referrel-list/create",

  PATIENT_DETAILS: "/admin/patients/details/:system_number",

  REVIEWS: "/admin/reviews",
  CONTACT_MESSAGES: "/admin/contact/messages",
  SUBSCRIBERS_LIST: "/admin/subcribers",
  CREATE_PRODUCT: "/admin/products/create",
  LOGIN: "/admin/login",
  RESET_PASSWORD: "/admin/reset-password",
  CHANGE_PASSWORD: "/admin/change-password/:code",
 //   Front Website Links
  HOME: "/",
  BLOG: "/blog",
  BLOG_DETAIL: "/blog/:slug",
  BRANDS: "/brands",
  BRAND_SINGLE: "/brands/:brandSlug",
  PRODUCTS: "/products",
  PRODUCT_SINGLE: "/products/:productSlug",
  CATEGORY_DETAIL: "/category/:categorySlug",
  CONTACT: "/contact",
  PRIVACY_POLICY: "/privacy-policy",
  TERMS: "/terms",
  FAQ: "/faq",
  ABOUT: "/about",
  BUSINESS_PROFILE: "/business-profile",
  VISIT_STORE: "/brands",


};

